import { render, staticRenderFns } from "./solutionWRZS.vue?vue&type=template&id=5a6ad40a&scoped=true"
import script from "./solutionWRZS.vue?vue&type=script&lang=js"
export * from "./solutionWRZS.vue?vue&type=script&lang=js"
import style0 from "./solutionWRZS.vue?vue&type=style&index=0&id=5a6ad40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ad40a",
  null
  
)

export default component.exports